export default __webpack_public_path__ + "locales/ja-JP/People.json?hash=a1ee1264017933f495033af7dacff75e";